// Client-side mirror of the backend CRM /meta constants. Used as a fallback so
// the CRM workspace layout renders even when the backend is unreachable (e.g. the
// local preview before deploy). Keep in sync with helpers/crm_config.js.
const defaultMeta = {
  stages: ['prospect', 'account_created', 'first_order_placed', 'active', 'warm_inactive', 'cold_inactive', 'lost'],
  lost_reasons: [
    'Do Not Call',
    'Do Not Email',
    'Not Interested',
    'Never Intended to Use Gophr',
    'Permanently Churned',
    'Competitor',
    'Pricing',
    'Service Issue',
    'Outside Service Area',
    'Outside Capabilities',
    'Business Closed',
    'Duplicate Account',
    'Bad Contact Information',
    'Other'
  ],
  contact_types: ['prospect', 'merchant', 'driver', 'investor'],
  roles: ['ADMIN', 'SALES'],
  ai_audiences: ['customers', 'drivers', 'investors'],
  ai_tones: ['professional', 'friendly', 'concise', 'excited'],
  pipeline_stages: {
    investor: [
      'prospect',
      'introduced',
      'contacted',
      'meeting_scheduled',
      'meeting_completed',
      'interested',
      'data_room',
      'due_diligence',
      'committed',
      'invested',
      'passed'
    ],
    driver: ['prospect', 'signup_started', 'docs_pending', 'approved', 'active', 'inactive', 'high_performer', 'suspended', 'removed']
  },
  email_provider: { provider: 'log', configured: true },
  categories: {
    Industrial: [
      'Oil & Gas',
      'Electrical',
      'Equipment',
      'Mechanical',
      'Valves / Pumps',
      'Automation / Instrumentation',
      'Fabrication',
      'Machine Shop',
      'Pipe / Fittings',
      'Industrial Supply',
      'Chemical',
      'Rental Equipment',
      'Manufacturing',
      'Construction',
      'HVAC',
      'Marine',
      'Energy',
      'Other Industrial'
    ],
    Pharmaceutical: [
      'Pharmacy',
      'Hospital',
      'Medical Supply',
      'Medical Equipment',
      'Laboratory',
      'Pharmaceutical Manufacturer',
      'Healthcare',
      'Other Pharmaceutical / Medical'
    ],
    Retail: [
      'Clothing',
      'Sporting Goods',
      'Lumber / Hardware',
      'Automotive',
      'Furniture',
      'Electronics',
      'Building Materials',
      'General Retail',
      'E-Commerce',
      'Other Retail'
    ],
    Individual: ['Marketplace Purchase', 'Personal Delivery', 'Moving / Hauling', 'Vehicle / Equipment Transport', 'Other Individual']
  }
};

export default defaultMeta;
